import React, {useState} from 'react'
import {InputText, Button, useLoading, useCurrentUser} from 'usg-lib'
import TwoFactorAuthenticationChallengeForm from './TwoFactorAuthenticationChallengeForm'
import {restUrls} from "../../../../utils/constants";
import axios from "axios";
import {defaultSupportEmail} from "../../../../utils/constants";
import {usePostHog} from "posthog-js/react";

const LoginForm = ({supportEmail}) => {
  const { loadCurrentUser } = useCurrentUser()
  const { showLoading, hideLoading } = useLoading()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [userLoginData, setUserLoginData] = useState({email: '', password: ''})
  const [errorMessage, setErrorMessage] = useState({})
  const [serverErrorCode, setServerErrorCode] = useState('')
  const [serverErrorMessage, setServerErrorMessage] = useState('')
  const posthog = usePostHog()

  const handleLoginInputChange = (e) => {
    const {name, value} = e.target;
    setUserLoginData({...userLoginData, [name]: value})
  }

  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.emailLogin = 'Email Address or Username is required';
    }
    if (!values.password) {
      errors.password = 'Password is required';
    }

    return errors;
  }

  const handleLoginSubmit = async () => {
    let errors = validate(userLoginData)
    setErrorMessage(errors)
    if (isSubmitting || Object.keys(errors).length !== 0) {
      posthog.capture('sso_login_error', {
        error: 'PreValidation',
      });

      return false;
    }
    setIsSubmitting(true)
    showLoading()

    const userFormData = new FormData();
    userFormData.append('email', userLoginData.email);
    userFormData.append('password', userLoginData.password);

    try {
      await axios.post(restUrls.authUrl, userFormData)
      await loadCurrentUser()
      hideLoading()
      posthog.capture('sso_login_success');
    } catch (error) {
      let errorCode = error.response.data.error
      setServerErrorCode(error.response.data.error)
      posthog.capture('sso_login_error', {
        error: errorCode,
      });

      let message = error.response.data.message
      if (errorCode === 'UserAuthenticationFailure') {
        message = 'There was an error while authenticating. Please check email address and/or password.';
      }
      if (errorCode === 'UserTemporarilyLocked' || errorCode === 'UserPermanentlyLocked') {
        message = error.response.data.errorMessage;
        if (supportEmail) {
          message = message.replace(defaultSupportEmail, supportEmail);
        }
      }
      if (errorCode === 'NoAccessibleHotels') {
        message = error.response.data.errorMessage;
      }
      if (errorCode === 'IdentityProviderAuthenticationRequired') {
        window.location.href = restUrls.internalUserLoginUrl + window.location.search;
        return;
      }
      setServerErrorMessage(message)
      hideLoading()
    }
    setIsSubmitting(false)

    return false;
  }

  if (serverErrorCode === 'AuthenticationRequires2FA') {
    return <TwoFactorAuthenticationChallengeForm />;
  }

  return (
    <>
      <InputText
        onKeyDown={(e) => ((e.key === 'Enter' ? handleLoginSubmit() : null))}
        label="Email Address or Username"
        name="email"
        placeholder="Email Address or Username"
        value={userLoginData.email}
        onChange={e => handleLoginInputChange(e)}
        error={errorMessage.emailLogin}
      />
      <InputText
        onKeyDown={(e) => ((e.key === 'Enter' ? handleLoginSubmit() : null))}
        label="Password"
        type="password"
        name="password"
        placeholder="Password"
        value={userLoginData.password}
        onChange={e => handleLoginInputChange(e)}
        error={errorMessage.password}
      />
      <Button variant="primary" onClick={handleLoginSubmit}>
        Login
      </Button>
      {serverErrorMessage && (
        <p className="error">{serverErrorMessage}</p>
      )}
    </>
  )
}

export default LoginForm;
